import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';

const AdminRoute = ({ component: Component }) => {
  const [isAdmin, setIsAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

  useEffect(() => {
    const verifyAdmin = async () => {
      const token = localStorage.getItem('adminToken');

      if (!token) {
        setIsAdmin(false);
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(`${API_URL}/api/admin/verify`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (response.data.success) {
          setIsAdmin(true);
          axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        } else {
          setIsAdmin(false);
          localStorage.removeItem('adminToken');
          localStorage.removeItem('adminAuthenticated');
        }
      } catch (error) {
        console.error('Admin verification failed:', error);
        setIsAdmin(false);
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminAuthenticated');
      } finally {
        setLoading(false);
      }
    };

    verifyAdmin();
  }, [API_URL]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen" style={{ backgroundColor: '#F3F0E2' }}>
        <div
          className="animate-spin rounded-full"
          style={{ width: 32, height: 32, border: '3px solid #E5E7EB', borderTopColor: '#8F0024' }}
        />
      </div>
    );
  }

  return isAdmin ? <Component /> : <Navigate to="/admin-login" />;
};

export default AdminRoute;
